// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1OMpq","title":"Info_title__giL5W","selects":"Info_selects__3d2p-","requiredAsterisk":"Info_requiredAsterisk__2Zy5w"};